var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex flex-row align-self-center" }, [
    _c(
      "div",
      { staticClass: "d-flex align-self-center" },
      [
        _c(
          "v-progress-circular",
          {
            attrs: {
              rotate: 270,
              size: 150,
              width: 20,
              value: _vm.progressRate,
              color: "primary",
            },
          },
          [
            _c(
              "div",
              { staticStyle: { "line-height": "1", "text-align": "center" } },
              [
                _c("span", { staticStyle: { "font-size": "xx-large" } }, [
                  _vm._v(_vm._s(_vm.progressRate) + " "),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v("%\n      "),
              ]
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ms-4 d-flex align-self-center flex-column" },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }